import { createContext } from 'react';
import { useSession } from './useSession';

export interface User {
  id: string;
  email: string;
  displayName: string;
  role: string;
  organizationId: string;
}

/**
 * The organization the signed-in user belongs to. GET /auth/session has always
 * returned this alongside the user; the provider used to drop it on the floor.
 * It is how a screen learns the REAL business name instead of hardcoding one.
 */
export interface Organization {
  id: string;
  name: string;
  timezone: string;
}

export interface SessionState {
  user: User | null;
  organization: Organization | null;
  status: 'loading' | 'authenticated' | 'anonymous';
  refresh: () => Promise<void>;
  logout: () => Promise<void>;
}

export const SessionContext = createContext<SessionState | undefined>(undefined);

export { useSession };
